import Vue from 'vue'
import Vuex from 'vuex'
import portfolio from './modules/portfolioStore'
import users from './modules/usersStore'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    portfolio,
    users,
  },
})



// WEBPACK FOOTER //
// ./src/-client-app/store/index.js